import Vue from 'vue'

Vue.filter('dateFormat', (value)=> {
	return moment(value, 'DD/MM/YYYY').format('DD.MM.YYYY')
})
Vue.filter('monthName', (value)=> {
	return moment(value, 'MM').locale('fr').format('MMMM')
})